<!--<template>
  <div class="wdi-container">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4 col-sm-6">
          <div class="wdi-card" :style="{borderLeft: `3px solid ${'#C0A04A'} !important`}">
            <div class="title pb-3" v-html="'What is IAHS Accreditation'"></div>
            <router-link to="/" class="ih-btn">
              <div class="d-flex align-items-center">
                <span v-html="'Explore'"></span>
                <span class="icon-arrow-right ml-2 icon"></span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="wdi-card" :style="{borderLeft: `3px solid ${'#C0A04A'} !important`}">
            <div class="title pb-3" v-html="'Discover who we are'"></div>
            <router-link to="/" class="ih-btn">
              <div class="d-flex align-items-center">
                <span v-html="'Explore'"></span>
                <span class="icon-arrow-right ml-2 icon"></span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="wdi-card" :style="{borderLeft: `3px solid ${'#C0A04A'} !important`}">
            <div class="title pb-3" v-html="'I Have Experience'"></div>
            <router-link to="/" class="ih-btn">
              <div class="d-flex align-items-center">
                <span v-html="'Explore'"></span>
                <span class="icon-arrow-right ml-2 icon"></span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>-->

<template>
  <div class="wdi-container">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4 col-sm-6">
          <div class="wdi-card" :style="'borderLeft:'+row.lineColor1">
            <div class="title pb-3" v-html="row.title1"></div>
            <router-link v-if="row.redirect1" :to="row.redirect1" class="ih-btn">
              <div class="d-flex align-items-center">
                <span v-html="row.button1"></span>
                <span class="icon-arrow-right ml-2 icon"></span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="wdi-card" :style="'borderLeft:'+row.lineColor2">
            <div class="title pb-3" v-html="row.title2"></div>
            <router-link v-if="row.redirect2" :to="row.redirect2" class="ih-btn">
              <div class="d-flex align-items-center">
                <span v-html="row.button2"></span>
                <span class="icon-arrow-right ml-2 icon"></span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="wdi-card" :style="'borderLeft:'+row.lineColor3">
            <div class="title pb-3" v-html="row.title3"></div>
            <router-link v-if="row.redirect3" :to="row.redirect3" class="ih-btn">
              <div class="d-flex align-items-center">
                <span v-html="row.button3"></span>
                <span class="icon-arrow-right ml-2 icon"></span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wdi-container {
  padding: 50px 0 20px;
  background: #0D0D34;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 0.7rem;
  width: 100%;
}
.title {
  color: #fff;
}
.wdi-card {
  line-height: 1; 
  padding-left: 24px;
  margin-bottom: 30px;
}
.ih-btn {
  font-size: 19px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .wdi-container {
    padding: 0
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .container-fluid {
    max-width: 720px;
    margin-right: auto;
    margin-left: auto;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .container-fluid {
    max-width: 1400px;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
